export enum E_AssistantActions {
  Archived = "archived",
  Urgent = "urgent",
  EmailSent = "email-sent",
  EmailLabeled = "email-labeled",
  CalendarEventCreated = "calendar-event-created",
  MeetingPrepDone = "meeting-prep-done",
  MeetingPrepScheduled = "meeting-prep-scheduled",
  MeetingPrepSkipped = "meeting-prep-skipped",
  MeetingPrepStarted = "meeting-prep-started",
  PersonSearch = "person-search",
  PodcastGenerated = "podcast-generated",
  EmailDrafted = "email-drafted",
}

export enum E_ServiceName {
  Email = "email",
  Calendar = "calendar",
}

export type T_AssistantLogs = {
  _id: string;
  service: string;
  serviceName: E_ServiceName;
  actions: E_AssistantActions[];
  category: string;
  reason: string;
  from?: string;
  subject?: string;
  feedback?: string;
  created?: Date;
};

export interface EALogsResponse {
  assistantLogs: {
    items: T_AssistantLogs[];
    _id: string;
  }[];
}
